import { showNotification } from "../../store/Central/selectors";

/**
 * Opens the Intercom messenger with a prefilled message. Intercom is booted in
 * `components/intercom.tsx` but can be absent (ad blocker, boot not finished), so the
 * message falls back to the clipboard rather than being lost.
 */
export const openSupportChat = (message: string): void => {
	if (typeof window !== "undefined" && window.Intercom) {
		window.Intercom("showNewMessage", message);
		return;
	}

	void navigator.clipboard?.writeText(message);
	showNotification({
		message:
			"Support-Chat konnte nicht geöffnet werden. Die Fehlerdetails wurden in die Zwischenablage kopiert.",
		type: "warning",
	});
};
